import dataActions from './data-actions';
import hotelSearchActions from './hotel-search-actions';
import inventoryActions from './inventory-action';
import globalDataActions from './global-data-actions';

let actions = Object.assign({}, dataActions, hotelSearchActions, inventoryActions, globalDataActions);

export default actions;
